import { canAccessAccountPricingOnBasename } from '../../../../../util/product-permissions';

/**
 * The account settings tab that should load by default for a basename.
 *
 * Verticals with a Product Catalog land there, since it is the tab pros reach
 * for the most. The remaining verticals have no Product Catalog, so they keep
 * landing on Account Info.
 *
 * @param {BASENAME} basename - The basename.
 * @returns {string}
 */
export const getDefaultAccountSettingsPath = basename =>
  canAccessAccountPricingOnBasename(basename)
    ? `/app/${basename}/account/settings/pricing`
    : `/app/${basename}/account/settings/details`;
